import React from "react";

const version = "Versión: 1.8.10";

export default function AppVersion() {
  return (
    <React.Fragment>{version}</React.Fragment>
  );
}
